export default "__VITE_ASSET__BDu6nKIc__"